import { BaseService } from '@/infra/services/base-service';
import { Line } from '@/types/entities/Line';
import { GetLinesMapper } from '@/core/mapper/line';
import type { GetLinesRequestDTO, GetLinesResponseDTO } from '@/core/dto/line/get-lines';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

export class LineService extends BaseService<Line> {
	private static instance: LineService;

	private constructor(public readonly basePath: string = '/line/') {
		super();
	}

	public static getInstance(): LineService {
		if (!LineService.instance) {
			LineService.instance = new LineService();
		}
		return LineService.instance;
	}

	public async listOptions(params: GetLinesRequestDTO): Promise<Line[]> {
		const url = this.basePath + `/${params.sector_id}`;
		const { data } = await this.getInstance().get(url, { params });
		return data;
	}

	public async getLines(params: GetLinesRequestDTO): Promise<SelectOption[]> {
		const url =
			this.basePath +
			`${params.sector_id}?organization_id=${params.organization_id}&company_id=${params.company_id}`;
		const { data } = await this.getInstance().get<GetLinesResponseDTO>(url);
		return new GetLinesMapper(data).toDomain();
	}
}
